import styled from 'styled-components';
import { useEsc } from 'common/hooks/useKeyDown';

const SliderModalOverlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  animation-name: fadeIn;
  animation-duration: 0.4s;
  z-index: 1001;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const SliderModalWrapper = styled.div<{ isOpen: boolean }>`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  position: fixed;
  right: 0;
  width: 50%;
  height: 100%;
  animation-name: slideIn;
  animation-duration: 0.4s;

  background-color: rgb(255, 255, 255);
  border: 1px solid ${props => props.theme.colors.transparentGray};

  @media only screen and (min-width: 1200px) {
    width: 50%;
  }
  @media only screen and (max-width: 1200px) and (min-width: 480px) {
    width: 60%;
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
  }

  @keyframes slideIn {
    from {
      right: -300px;
      opacity: 0;
    }
    to {
      right: 0;
      opacity: 1;
    }
  }
`;

const SliderModalContent = styled.div`
  overflow-y: auto;
  position: relative;
`;

interface SliderModalProps {
  isOpen: boolean;
  closeModal: () => void;
  children: React.ReactNode;
  className?: string;
}

const SliderModal = (props: SliderModalProps) => {
  const { isOpen = false, closeModal = () => {}, children = '', className } = props;
  useEsc(closeModal, isOpen);

  const onOverlayClick = e => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <SliderModalOverlay onClick={onOverlayClick} className={className}>
      <SliderModalWrapper
        className="SliderModal"
        isOpen={isOpen}
        role="dialog"
        style={{ overflowY: 'unset' }}
      >
        <SliderModalContent className="SliderModal_content">{children}</SliderModalContent>
      </SliderModalWrapper>
    </SliderModalOverlay>
  );
};

export default SliderModal;
